import { FC } from 'react';

import { useRouter } from '@cvt/routing';

import { CreateStoryPartial } from '../partials/CreateStoryPartial';


export const CreateStory: FC = () => {
  const router = useRouter();

  return (
    <CreateStoryPartial onSuccess={story => router.stories.edit(story.id).go()}/>
  );
};
